import { Store } from 'redux/root';
import { ErrorPayload } from './types';

export const selectorGetError = (store: Store): ErrorPayload => {
	return store.errorRedux.error;
};
